import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

export const GeneralInfoBoxStyled = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: '16px',
  marginBottom: '24px',
});
